import * as ToggleMenuFlyoutEvent from '@ori-events/toggle-menu-flyout';
import { ButtonBase, Link, styled } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';
import type { VFC } from 'react';

import { DESKTOP_BREAKPOINT } from '~/constants';
import { useNavigationContext } from '~/contexts/NavigationContext';
import { dispatchToggleMenu } from '~/helpers';
import { createMarginWithImportant } from '~/utils/createMarginWithImportant';

const JoinLabel = styled(Link)<{
  disableRipple?: boolean;
}>(({ theme }) => ({
  [theme.breakpoints.up(DESKTOP_BREAKPOINT)]: {
    color: theme.palette.text.primary,
    display: 'block',
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightBold,
    marginRight: createMarginWithImportant(theme, 6),
    textDecoration: 'none',

    '&:hover, &:focus, &:active': {
      color: theme.palette.grey[600],
      cursor: 'pointer',
    },
  },

  [theme.breakpoints.up('lg')]: {
    marginRight: createMarginWithImportant(theme, 8),
  },
}));

const handleClick = () => dispatchToggleMenu(ToggleMenuFlyoutEvent.MenuTypes.JoinMenu);

export const JoinIcon: VFC = () => {
  const { joinLabel, joinTiles, joinUrl } = useNavigationContext();
  const { getTestId } = useTestId();

  if (joinTiles.length > 0) {
    return (
      <JoinLabel
        disableRipple
        as={ButtonBase}
        data-testid={getTestId('join-label')}
        onClick={handleClick}
      >
        {joinLabel}
      </JoinLabel>
    );
  }

  if (joinUrl) {
    return <JoinLabel href={joinUrl}>{joinLabel}</JoinLabel>;
  }

  return null;
};
